import {createContext, ReactNode, useContext, useState} from "react"
import {AppFwContext} from "./AppFwContext.ts"

export interface AppFwConfigProviderProps {
    readonly appFwContext: AppFwContext;
    readonly children?: ReactNode;
}

export const AppFwContextContext = createContext<undefined | AppFwContext>(undefined)

export const AppFwContextContextProvider = (props: AppFwConfigProviderProps) => {

    const [appFwContext] = useState<AppFwContext>(props.appFwContext)

    return <AppFwContextContext.Provider value={appFwContext}>{props.children}</AppFwContextContext.Provider>
}

export const useAppFwContext = () => {
    const appFwContext = useContext(AppFwContextContext)
    if (!appFwContext) {
        throw new Error("AppFwContext provider missing")
    }
    return appFwContext
};